(() => {
  if (window.mdShopMenuReady) return;
  window.mdShopMenuReady = true;
  const selector = '[data-md-shop-menu]';
  const setOpen = (item, open) => {
    item.toggleAttribute('data-open', open);
    item.querySelector('[data-md-shop-toggle]')?.setAttribute('aria-expanded', String(open));
  };
  const closeAll = (except) => document.querySelectorAll(selector).forEach(item => {
    if (item !== except) setOpen(item, false);
  });
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-md-shop-toggle]');
    if (toggle) {
      const item = toggle.closest(selector);
      const open = !item.hasAttribute('data-open');
      closeAll(item);
      setOpen(item, open);
    } else if (!event.target.closest(selector)) {
      closeAll();
    } else if (event.target.closest('a')) {
      closeAll();
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const open = document.querySelector(`${selector}[data-open]`);
      if (open) {
        closeAll();
        open.querySelector('[data-md-shop-toggle]')?.focus();
        event.preventDefault();
      }
    }
    if (event.key === 'ArrowDown' && event.target.matches('[data-md-shop-toggle]')) {
      const item = event.target.closest(selector);
      closeAll(item);
      setOpen(item, true);
      // Keep focus on the disclosure; Tab enters the links in their normal order.
      event.preventDefault();
    }
  });
  document.addEventListener('focusin', event => {
    if (!event.target.closest(selector)) closeAll();
  });
  window.matchMedia('(min-width: 1070px)').addEventListener('change', () => closeAll());
})();
